const vuexModules = {
    namespaced: true,
    state: {
        play_date: '',
        back_screen: ''
    },
    mutations: {
        setPlay_date (state, val) {
            state.play_date = val;
        },
        setBack_screen (state, val) {
            state.back_screen = val;
        }
    }
};

export default vuexModules;
